var React = require('react');

function Grow (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M8.45831 44.6843L22.9583 30.1601L32.625 39.8268L53.1666 16.7234L49.7591 13.3159L32.625 32.5768L22.9583 22.9101L4.83331 41.0593L8.45831 44.6843Z"}));
}

Grow.defaultProps = {"width":"58","height":"58","viewBox":"0 0 58 58","fill":"none"};

module.exports = Grow;

Grow.default = Grow;
